import { getCookie } from "cookies-next";
import sha256 from "crypto-js/sha256";
import posthog from "posthog-js";

import fetcher from "~/utils/fetcher.client";
import getUserIPAddress from "~/utils/getUserIPAddress";

export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
const CONVERSION_API_URL = `https://graph.facebook.com/v18.0/${FB_PIXEL_ID}/events?access_token=${process.env.NEXT_PUBLIC_FB_CONVERSION_API_ACCESS_TOKEN}`;

export const pageView = () => {
	window.fbq("track", "PageView");
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name: string, options = {}) => {
	window.fbq("track", name, options);
};

interface FBEvent {
	event_name: string;
	event_id: string;
	user_data?: {
		first_name?: string;
		last_name?: string;
		email?: string;
	};
	custom_data?: {
		currency: string;
		value: number;
	};
}

// https://developers.facebook.com/docs/marketing-api/conversions-api/using-the-api
export const FBConversionAPIEvent = async (event: FBEvent) => {
	const { event_name, custom_data, user_data, event_id } = event;
	try {
		const fbp = getCookie("_fbp");
		const fbc = getCookie("_fbc");
		const hashedUserData = hashUserData(user_data);

		await fetcher(CONVERSION_API_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},

			data: {
				data: [
					{
						event_name,
						event_id,
						event_time: Math.floor(Date.now() / 1000),
						user_data: {
							client_ip_address: await getUserIPAddress(),
							client_user_agent: navigator.userAgent,
							fbp,
							fbc,
							...hashedUserData,
						},
						custom_data: custom_data || {},
						event_source_url: window.location.href,
						action_source: "website",
					},
				],
			},
		});
	} catch (error) {
		posthog.captureException(error);
	}
};

const hashUserData = (userData: FBEvent["user_data"]) => {
	const { first_name, last_name, email } = userData || {};
	return {
		em: sha256(email || "").toString(),
		fn: sha256(first_name || "").toString(),
		ln: sha256(last_name || "").toString(),
	};
};
